<template>
  <editor
    v-if="showEditor"
    :id="id"
    :key="'tinyMce'+id"
    v-model="content"
    api-key="10idzplubs6a0oyjggraa93y181syy4du6bsgj41dh3e9nwm"
    :disabled="readonly"
    :init="initSettings"
  />
</template>

<script>
import Editor from '@tinymce/tinymce-vue'

export default {
    name: 'TinyMce',
    components: {
      Editor
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      insertContent: {
        type: String,
        default: null
      },
      width: {
        type: String,
        default: '22cm'
      },
      simple: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      id: {
        type: String,
        default: 'tinymce-editor'
      },
      minHeight: {
        type: Number,
        default: 250
      }
    },
    data() {
      return {
        showEditor: false
      }
    },
    computed: {
      content: {
        set: function (value) {
          this.$emit('input', value)
        },
        get: function () {
          return this.value
        }
      },
      initSettings() {
        let settings = {
          plugins: 'preview link table charmap hr insertdatetime pagebreak advlist lists wordcount code image',
          image_advtab: true,
          width: this.width,
          pagebreak_separator: '<div class="pagebreak"></div>',
          valid_children: '+body[style]'
        }

        if (this.simple) {
          settings.toolbar = 'bold italic underline strikethrough | numlist bullist outdent indent | removeformat'
          settings.menubar = false
          settings.content_css = process.env.BASE_URL + 'tinymce/content_simple.css'
          settings.min_height = this.minHeight
        } else {
          settings.toolbar = 'formatselect fontselect fontsizeselect | bold italic underline strikethrough forecolor backcolor | image | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat'
          settings.content_css = process.env.BASE_URL + 'tinymce/content_document.css'
          settings.height = '100%'
        }

        return settings
      }
    },
    watch: {
      insertContent(value) {
        if (!value || !window.tinymce) return

        window.tinymce.get(this.id).insertContent(value)

        this.$emit('update:insert-content', null)
      }
    },
    mounted() {
      this.showEditor = true
    }
  }
</script>
